import QueryString from 'querystring';

let actions = {};

//Create a form and send it with a token input
actions.form = ({ args, previous_action, storage=null }) => {
    if (storage) {
        storage.remove();
    }

    // We only use the first argument
    const [arg] = args;

    let form = document.createElement('form');
    form.style.display = 'none';
    form.method = 'POST'

    let urlParams = new URLSearchParams(window.location.search);
    let query = {};

    const IGNORED_QUERY_PARAMS = ['token', 'locale'];
    let entries = [];

    try {
        entries = urlParams.entries();
    } catch (e) {
        //Do nothing here
    }

    // TODO add whitelist/blacklist
    for(let [key, value] of entries) { // eslint-disable-line no-unused-vars
        if(IGNORED_QUERY_PARAMS.includes(key)) {
            continue;
        }

        query[key] = value;
    }

    // New format
    if(arg.url) {
        // Add query params to current query
        // keeping Neo query for priority because
        // params were in URL (set by integration)
        query = {
            ...arg.query,
            ...query
        };
    }

    query = QueryString.stringify(query);

    if(arg.url) {
        form.action = `${arg.url}?${query}`;
    } else if(arg.action) {
        if(!arg.action.includes('?')) {
            query = `?${query}`;
        } else {
            query = `&${query}`;
        }

        // Local testing
        // TODO: find a better way to handle this
        // form.action = arg.action.replace('https://www.weezevent.be', 'http://localhost:7080') + query;
        form.action = arg.action + query;
    }

    let tokenInput = document.createElement("input");
    tokenInput.type = "hidden";
    tokenInput.name = "token";
    tokenInput.value = arg.parameters.token;

    form.appendChild(tokenInput);
    document.body.appendChild(form);

    return Promise.resolve(form.submit());
};


actions.redirect = ({ args, previous_action, storage=null }) => {
    const [{ url, query }] = args;
    const query_params = new URLSearchParams();
    for(const [k, v] of Object.entries(query)) { // eslint-disable-line no-unused-vars
        query_params.append(k, v);
    }

    const querystring = query_params.toString();

    const final_url = `${url}?${querystring}`;
    window.location.href = final_url;
    return Promise.resolve();
};

function downloadPDF(pdf, filename) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = filename;
    downloadLink.click();
}

actions.download = ({ args, history, step, setStep }) => {
    const { url, file_base64, filename } = args[0];
    if (url) {
        window.open(url, 'Download');
    } else {
        downloadPDF(file_base64, filename);
    }

    let prevStep = history.filter(s => s.slug !== step.slug).at(-1);
    setStep(prevStep);
    return Promise.resolve();
}

export default actions;
